import React from 'react';
import PropTypes from 'prop-types';
import '../cartaGeneral.css';
import ImageContainer from '../ImagesContainer';
import getClassName from '../getClassName';

const TwoSectionTable = ({ section, isResto }) => {
  return (
    <div
      className={getClassName('containerClass', isResto)}
      key={section.title}
    >
      <h1 className={getClassName('sectionTitle', isResto)}>
        {`${section.title}${section.engTitle ? ` (${section.engTitle})` : ''}`}
      </h1>
      <hr className={getClassName('separatorClass', isResto)} />
      <div className={getClassName('tableContainer', isResto)}>
        <table className={getClassName('tableClass', isResto)}>
          <tbody>
            {section.subSections.map((subSection) => {
              return (
                <>
                  {subSection.title && (
                    <h2 className={getClassName('subSectionTitle', isResto)}>
                      {`${subSection.title}${
                        subSection.engTitle ? ` (${subSection.engTitle})` : ''
                      }`}
                    </h2>
                  )}
                  {subSection.items.map((item) => {
                    return (
                      <tr
                        className={getClassName('trElement', isResto)}
                        key={item.text}
                      >
                        <td
                          className={getClassName('tdElement', isResto)}
                          style={{ width: '90%' }}
                        >
                          <h5 className={getClassName('h5Element', isResto)}>
                            {item.text}
                          </h5>
                          {item.engText && (
                            <h5 className={getClassName('h5Element', isResto)}>
                              {`(${item.engText})`}
                            </h5>
                          )}
                        </td>
                        <td
                          className={getClassName('tdElement', isResto)}
                          style={{ width: '10%' }}
                        >
                          <h5 className={getClassName('h5Element', isResto)}>
                            {item.price ? `$${item.price}` : '-'}
                          </h5>
                        </td>
                      </tr>
                    );
                  })}
                </>
              );
            })}
          </tbody>
        </table>
      </div>
      <ImageContainer
        imgLg={section.imgLg}
        imgSm={section.imgSm}
        img={section.img}
        title={section.title}
        isResto={isResto}
      />
    </div>
  );
};

TwoSectionTable.propTypes = {
  section: PropTypes.shape({
    imgLg: PropTypes.any,
    imgSm: PropTypes.any,
    img: PropTypes.any,
    engTitle: PropTypes.string,
    title: PropTypes.string,
    subSections: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        items: PropTypes.arrayOf(
          PropTypes.shape({
            text: PropTypes.string,
            price: PropTypes.any,
          })
        ),
      })
    ),
  }),
  isResto: PropTypes.bool,
};

TwoSectionTable.defaultProps = {
  isResto: false,
};

export default TwoSectionTable;
